const localDay = date => `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`
export function groupAlertReceiptsByDay(receipts, now = new Date()) {
  const today = localDay(now), yesterday = new Date(now)
  yesterday.setDate(yesterday.getDate() - 1)
  const groups = new Map()
  for (const receipt of receipts) {
    const date = new Date(receipt.firedAt || receipt.createdAt)
    const valid = Number.isFinite(date.getTime())
    const key = valid ? localDay(date) : 'unknown'
    if (!groups.has(key)) groups.set(key, {
      key, label: !valid ? 'Date unavailable' : key === today ? 'Today' : key === localDay(yesterday) ? 'Yesterday' : date.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' }),
      receipts: [],
    })
    groups.get(key).receipts.push(receipt)
  }
  return [...groups.values()]
}
